import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NonceService {

  constructor(private http: HttpClient) {}

  getNonce(): Observable<string> {
    return this.http.get(environment.urlNonce, { observe: 'response', responseType: 'text' }).pipe(
      map(response => {
        const headers: HttpHeaders = response.headers;
        // Aquí asume que el nonce está en un encabezado personalizado, ajusta según sea necesario
        const nonce = response.headers.get('X-Content-Security-Policy');
        console.log('Response Headers:', headers.keys());
        console.log('Extracted Nonce:', nonce);
        return nonce || '';
      })
    );
  }
  
}
